exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-link {\n  color: #212529;\n}\n\n.nav-link.active {\n  color: #007bff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/web-demos/web-demos.component.css
// module id = 156
// module chunks = 1